import { MediaImageStandard } from 'components/Contentful'
import { Check } from 'react-feather'
import { Eyebrow } from 'components/Eyebrow'
import { Typography, LinkButton } from 'components/Contentful'
import { BLOCKS } from '@contentful/rich-text-types'
import AppStoreButtons from 'components/AppStoreButtons/AppStoreButtons'

export const DebtSolutionsCards = ({
  card,
  fixedH,
  containerClassName,
  itemsPadding,
  buttonClassName,
}) => {
  const {
    cardBadgeImage,
    eyebrow,
    cardTitleText,
    cardText,
    cardLink,
    secondaryCardLink,
    linkApple,
    linkAndroid,
    imageApple,
    imageAndroid,
  } = card

  return (
    <div
      className={
        containerClassName
          ? containerClassName
          : `flex flex-col justify-center px-6 rounded-[10px] max-w-[336px] lg:w-[336px] bg-[#F8F9FC] py-[18px] ${
              fixedH ? 'h-[454px]' : ''
            }`
      }
      data-testid="lending-debt-solutions-item"
    >
      {/* Image */}
      {cardBadgeImage && (
        <div className="mt-2 flex justify-center">
          <MediaImageStandard
            layout="fixed"
            width={80}
            height={80}
            altText={cardBadgeImage.filename}
            content={cardBadgeImage}
          />
        </div>
      )}

      {/* Eyebrow */}
      {eyebrow && (
        <div className="mt-[20px]">
          <Eyebrow content={eyebrow} black={true} />
        </div>
      )}

      {/* Title */}
      <div className="mt-[4px]  flex justify-center">
        <Typography
          className="text-center text-[#1D252F] font-ultramarine text-[20px] font-medium leading-[120%]"
          content={cardTitleText}
          data-testid="debt-solutions-item-title"
        />
      </div>

      {/* Main text with checks */}
      {cardText && (
        <div
          className={`mt-[20px] flex flex-col gap-[12px] ${itemsPadding || ''}`}
          data-testid="debt-solutions-item-list-container"
        >
          {cardText?.json?.content
            ?.filter((node) => node.nodeType === 'unordered-list')
            .flatMap((list) => list.content)
            .map((listItem, index) => {
              const text = listItem?.content?.[0]?.content?.[0]?.value

              if (!text) return null

              const itemKey =
                listItem?.sys?.id ??
                listItem?.data?.target?.sys?.id ??
                `debt-solutions-bullet-${index}`

              return (
                <div
                  key={itemKey}
                  className="flex items-start m-0 md:m-auto lg:m-0 gap-[8px]"
                  data-testid="debt-solutions-item-list-item"
                >
                  <Check className="text-[#8AB0F0]" size={16} />
                  <Typography
                    className="text-nowrap text-[#42546B] font-ultramarine text-[14px] font-normal leading-[140%]"
                    variant="bodyMd"
                    content={text}
                  />
                </div>
              )
            })}
        </div>
      )}

      {/* First button */}
      {cardLink && (
        <div
          className={`mt-[20px] w-full flex flex-col items-center ${
            !secondaryCardLink && !linkApple ? 'mb-[20px]' : ''
          }`}
          data-testid="debt-solutions-item-primary-button"
        >
          <LinkButton
            className={
              buttonClassName ||
              'text-[13px] px-[24px] py-[14px] min-h-10 lg:min-h-12 lg:text-[18px] w-fit mx-auto max-h-12 lg:min-w-[179px]'
            }
            track={{
              click_position: '0',
              click_id: cardLink.linkText.json.content[0].content[0].value,
              click_text: cardLink.linkText.json.content[0].content[0].value,
              track_event: 'internal_campaign_click',
              event_action: 'button_click',
              event_type: 'button_click',
              ...cardLink?.event,
            }}
            content={{
              linkText: cardLink.linkText.json.content[0].content[0].value,
              linkHref: cardLink.linkHref,
            }}
            typographicOptions={{
              variantOverride: { [BLOCKS.PARAGRAPH]: 'bodyLg' },
              fontWeight: 'bold',
            }}
            color="primary"
            variant={LinkButton.VARIANTS.CONTAINED}
          />
        </div>
      )}

      {linkApple && linkAndroid && imageApple && imageAndroid && (
        <div className="mt-[20px]">
          <AppStoreButtons
            appleButton={linkApple}
            googleButton={linkAndroid}
            appleImage={imageApple}
            googleImage={imageAndroid}
            overflow={true}
            navLinkSection="Lending Solutions"
          />
        </div>
      )}

      {/* Second button */}
      {secondaryCardLink && (
        <div
          className="mt-[20px] mb-[23px] w-full flex flex-col items-center"
          data-testid="debt-solutions-item-secondary-button"
        >
          <LinkButton
            className={
              buttonClassName ||
              'text-[13px] px-[24px] py-[14px] min-h-10 lg:min-h-12 lg:text-[18px] w-fit mx-auto max-h-12 lg:min-w-[179px]'
            }
            track={{
              click_position: '0',
              click_id: secondaryCardLink.linkText.json.content[0].content[0].value,
              click_text: secondaryCardLink.linkText.json.content[0].content[0].value,
              track_event: 'internal_campaign_click',
              event_action: 'button_click',
              event_type: 'button_click',
              ...secondaryCardLink?.event,
            }}
            content={{
              linkText: secondaryCardLink.linkText.json.content[0].content[0].value,
              linkHref: secondaryCardLink.linkHref,
            }}
            typographicOptions={{
              variantOverride: { [BLOCKS.PARAGRAPH]: 'bodyLg' },
              fontWeight: 'bold',
            }}
            color="secondary"
            variant={LinkButton.VARIANTS.CONTAINED}
            fullWidth={true}
          />
        </div>
      )}
    </div>
  )
}
